import React, {useEffect, useState} from "react";
import {Button, Input, Select, Table, message} from "antd";
import {config} from "../../../../../shared/config/config";
import {FlatListingsService} from "../../../../../shared/api/flatListings/flatListings.service";
import "./ListingsSection.scss";

// «Выставка квартир за период» — ECI old's KPI report (services/vistavka-vitrina.html): who listed which flats on
// sale now, their grade, view, instalments, made or copied, when; the counts by kind and the average grade. The
// server works it out (backend service/flatListings.service.js).

// a date in Moscow as 'YYYY-MM-DD'
const dayOf = (date) => date.toLocaleDateString('sv-SE', {timeZone: 'Europe/Moscow'})
const firstOfMonth = () => `${dayOf(new Date()).slice(0, 8)}01`
const momentOf = (at) => new Date(at).toLocaleString('ru-RU', {timeZone: 'Europe/Moscow'}).replace(',', '')
const byLabel = (input, option) => String(option.label || '').toLowerCase().includes(input.toLowerCase())
const yes = (value) => (value ? <b>Да</b> : '')

const COLUMNS = [
  {title: 'ID квартиры', dataIndex: 'id', width: 120, render: (id, row) => (
    <>
      <a href={`${config.API_HOST}/apartments/${id}`} target='_blank' rel='noopener noreferrer'>{id}</a>
      {row.eciOldId && <div className='listings__old'>№ {row.eciOldId}</div>}
    </>
  )},
  {title: 'Жилой комплекс', dataIndex: 'complex', render: (complex) => complex || 'Не указан'},
  {title: 'Оценка', dataIndex: 'grade', width: 130, render: (grade) => grade || 'Не указана'},
  {title: 'Видовая', dataIndex: 'view', width: 90, render: yes},
  {title: 'Рассрочка', dataIndex: 'installment', width: 100, render: yes},
  {title: 'Тип выставки', dataIndex: 'kind', width: 130,
    render: (kind) => <span className={`listings__kind listings__kind--${kind === 'копирование' ? 'copy' : 'create'}`}>{kind}</span>},
  {title: 'Кто выставил', dataIndex: 'user', render: (user) => user || 'Неизвестно'},
  {title: 'Дата и время выставки', dataIndex: 'at', width: 170, render: momentOf},
]

const EMPTY = {from: firstOfMonth(), to: dayOf(new Date()), user: undefined, complexId: undefined}

export const ListingsSection = () => {
  const [filters, setFilters] = useState(EMPTY)
  const [options, setOptions] = useState({users: [], complexes: []})
  const [report, setReport] = useState(null)
  const [loading, setLoading] = useState(false)

  const load = async (asked = filters) => {
    if (!asked.from || !asked.to) {
      message.warning('Укажите обе даты')
      return
    }
    setLoading(true)
    try {
      const {data} = await FlatListingsService.fetchReport(asked)
      setReport(data)
    } catch (error) {
      message.error(error?.response?.data?.errors?.message || 'Не удалось построить отчёт')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    FlatListingsService.fetchOptions().then(({data}) => setOptions(data)).catch(() => {})
    load(EMPTY)
    // eslint-disable-next-line
  }, [])

  const set = (key) => (value) => setFilters((current) => ({...current, [key]: value}))
  const reset = () => {
    setFilters(EMPTY)
    load(EMPTY)
  }

  return (
    <div className='listings'>
      <div className='listings__filters'>
        <label>
          <span>Дата (начиная с)</span>
          <Input type='date' value={filters.from} onChange={(e) => set('from')(e.target.value)}/>
        </label>
        <label>
          <span>Дата (до)</span>
          <Input type='date' value={filters.to} onChange={(e) => set('to')(e.target.value)}/>
        </label>
        <label>
          <span>Пользователь</span>
          <Select showSearch allowClear placeholder='Все пользователи' value={filters.user} onChange={set('user')}
                  options={options.users} filterOption={byLabel}/>
        </label>
        <label>
          <span>Жилой комплекс</span>
          <Select showSearch allowClear placeholder='Все ЖК' value={filters.complexId} onChange={set('complexId')}
                  options={options.complexes} filterOption={byLabel}/>
        </label>
        <div className='listings__buttons'>
          <Button type='primary' onClick={() => load()} loading={loading}>Показать выставку</Button>
          <Button onClick={reset}>Сбросить фильтры</Button>
        </div>
      </div>

      {report && (
        <>
          <h2 className='listings__title'>Выставка квартир за период</h2>
          <div className='listings__stats'>
            <div>
              <h3>Статистика по типам выставки</h3>
              {Object.entries(report.kinds).map(([kind, count]) => (
                <div key={kind}><span className='listings__label'>{kind}</span> — {count} квартир</div>
              ))}
            </div>
            <div>
              <h3>Средняя оценка</h3>
              <div><span className='listings__label'>Средняя оценка квартир</span> — {report.average}</div>
              <div><span className='listings__label'>Учтено квартир с оценкой</span> — {report.graded}</div>
            </div>
          </div>
          <Table className='listings__table' size='small' rowKey='id' columns={COLUMNS} dataSource={report.items}
                 loading={loading} pagination={{defaultPageSize: 100, showSizeChanger: true, showTotal: (total) => `Всего ${total}`}}/>
        </>
      )}
    </div>
  )
}
